import React from "react"

import { Box, Flex, Shimmer } from "components/common/index"

const WizardLoading = () => (
  <>
    {/* Wizard Options*/}
    {[...Array(3)].map((opt, i) => (
      <Box
        bg="white"
        borderBottom="1px solid"
        borderColor="grey.10"
        key={`load${i}`}
        p="10px"
      >
        <Flex alignItems="center" justifyContent="space-between">
          <Flex alignItems="center">
            <Shimmer borderRadius="50%" height="40px" mr="15px" width="40px" />
            <Box>
              <Shimmer height="10px" mb="5px" width="100px" />
              <Shimmer height="10px" width="160px" />
            </Box>
          </Flex>
          <Shimmer height="14px" width="60px" />
        </Flex>
      </Box>
    ))}
  </>
)

export default WizardLoading
